import TranslationsTransformer from "@/transformers/translations.transformer"
import HttpClientService from "./httpClient.service"

import { getFormattedDate } from "@/utils/unixTimestampToDate"
import { TRANSLATIONS_EXPIRATION_DATE_COOKIE, cookiesService } from "@/services/cookies.service"

class TranslationsService extends HttpClientService {
  constructor() {
    super({ baseUri: "/api/translations", transformer: TranslationsTransformer })
  }

  getAll() {
    return this.getCollection(null, {
      needsAuth: false,
      transformerMethod: "fetch"
    })
  }

  // property tlu: Contains the date in unix timestamp of the last update of the translation table.
  isLoadTranslationsNeedIt(tlu) {
    let lastBackedTranslationUpdateDate = getFormattedDate(tlu)
    let expirationDateCookie = cookiesService.get(TRANSLATIONS_EXPIRATION_DATE_COOKIE)
    let translationsExpirationDate = new Date(expirationDateCookie)

    return lastBackedTranslationUpdateDate > translationsExpirationDate
  }
}

const translationsService = new TranslationsService()

export default translationsService
